import { render } from "./CartCompleted.vue?vue&type=template&id=011ea976"
import script from "./CartCompleted.vue?vue&type=script&lang=js"
export * from "./CartCompleted.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__